import {computed, inject, Injectable, Signal} from '@angular/core';

import {Layout, Measure, SortingStrategyId, TileDisplay} from '@selpia/shared/models';

import {OptionsStore} from '../state/options.store';

@Injectable({
  providedIn: 'root',
})
export class OptionsFacade {
  readonly #store = inject(OptionsStore);

  readonly focusPeriod: Signal<string | undefined> = this.#store.focusPeriod;
  readonly focusMeasure: Signal<Measure | undefined> = this.#store.focusMeasure;
  readonly colouringStrategy: Signal<string | undefined> = this.#store.colouringStrategy;
  readonly sortType: Signal<SortingStrategyId> = this.#store.sortType;

  readonly layout: Signal<Layout> = this.#store.layout;
  readonly tileDisplay: Signal<TileDisplay> = this.#store.tileDisplay;

  readonly impactMeasure: Signal<Measure | undefined> = computed(() => this.focusMeasure()?.impactMeasure);
}
